function checkLocalStorage(): boolean {
  return typeof window !== 'undefined' && typeof localStorage !== 'undefined'
}

export const hasLocalStorage = checkLocalStorage()
